import type { Entities, STChecklistItem } from '@st/sdk'
import { formatEntities } from '@st/util/entities'

export function formatFolderEntityName(
  entities: Entities | undefined,
  audience: 'client' | 'internal' | 'salutation' = 'internal'
) {
  return formatEntities(entities ?? {}, audience)
}
